import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IBrandParams, IBrandResponse, IBrandState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateBrand = createAsyncThunk(
  'listBrands/fetchCreateBrand',
  async (params: IBrandParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createBrand(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IBrandState = {
  isLoading: false,
  response: null,
  error: null
}

const createBrandSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetCreateBrand: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateBrand.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateBrand.fulfilled, (state, action: PayloadAction<IBrandResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateBrand.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createBrandSlice.reducer
export const { resetCreateBrand } = createBrandSlice.actions
